import React from 'react'
import Header from './Header'
import Footer from './Footer'

export default props => (
	<>
		<Header />
		<div className="main-content-area">
			{props.children}
			<Footer />
		</div>
	</>
)
